import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { InterLinksState, SLICE_NAME } from './models';

const interLinksSelector = (state: RootState): InterLinksState => state[SLICE_NAME];

export const selectInterLinks = createSelector(interLinksSelector, (state: InterLinksState) => state.interLink);

export const selectInterLinksIsLoading = createSelector(
  interLinksSelector,
  (state: InterLinksState) => state.isLoading,
);

export const selectInterLinksError = createSelector(interLinksSelector, (state: InterLinksState) => state.error);

export const selectInterLinksPagination = createSelector(
  interLinksSelector,
  (state: InterLinksState) => state.pagination,
);
